import { useState, useEffect } from "react";

interface UseTypewriterOptions {
  texts: string[];
  typingSpeed?: number;
  erasingSpeed?: number;
  pauseDuration?: number;
  enabled: boolean;
}

export const useTypewriter = ({
  texts,
  enabled,
  typingSpeed = 60,
  erasingSpeed = 30,
  pauseDuration = 2000,
}: UseTypewriterOptions) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [displayedText, setDisplayedText] = useState("");
  const [isTyping, setIsTyping] = useState(true);

  useEffect(() => {
    const currentText = texts[currentIndex];
    let timeoutId: NodeJS.Timeout;

    if (isTyping) {
      if (displayedText.length < currentText.length) {
        // Typing forward
        timeoutId = setTimeout(() => {
          setDisplayedText(currentText.slice(0, displayedText.length + 1));
        }, typingSpeed);
      } else {
        // Pause at end, then start erasing
        timeoutId = setTimeout(() => {
          setIsTyping(false);
        }, pauseDuration);
      }
    } else {
      if (displayedText.length > 0) {
        // Erasing
        timeoutId = setTimeout(() => {
          setDisplayedText(displayedText.slice(0, -1));
        }, erasingSpeed);
      } else {
        // Move to next text and start typing
        setCurrentIndex((prev) => (prev + 1) % texts.length);
        setIsTyping(true);
      }
    }

    return () => clearTimeout(timeoutId);
  }, [
    displayedText,
    isTyping,
    currentIndex,
    texts,
    typingSpeed,
    erasingSpeed,
    pauseDuration,
  ]);

  return enabled ? displayedText : null;
};
